import { Modal as MModal, ModalBody, ModalContent, ModalProps as MModalProps }from "@heroui/react";
import { useTranslation } from 'react-i18next';

import Button from './Button';
import FlexRow from './FlexRow';

export interface ModalProps extends MModalProps {
  title:				string;
  message:				string;
  onResult:				(obj: Object, result: string) => any;
}

export const Modal = (mprops: ModalProps) => {
  const { children, backdrop, defaultOpen, classNames, onClose, onResult, radius, title, message, ...props} = mprops;
  
  const oc = () => {
    if (onClose)
      onClose();
    
    onResult({}, "");
  };
  
  return (
  <MModal backdrop="opaque" 
         defaultOpen={true} 
         classNames={{
           backdrop: "bg-[#0000007f]",
           wrapper: "modalShadow"
         }}
         onClose={oc}
         radius="none">
    <ModalContent>
      <ModalBody className="min-w-[420px] p-[16px]">
        <FlexRow direction="column">
          <FlexRow className="m14 text-black pb-[24px]">
            { title }
          </FlexRow>
          <FlexRow className="r12 text-black pb-[32px]">
            { message }
          </FlexRow>
          { children }
        </FlexRow>
      </ModalBody>
    </ModalContent>
  </MModal>
  );
};

export const DeleteModal = (mprops: ModalProps) => {
  const { t } = useTranslation();
  
  const { children, ...props } = mprops;
  const oc = () => {
    if (props.onClose)
      props.onClose();
    
    props.onResult({}, "");
  };
  
  return (
  <Modal {...props}>
      { children }
      <FlexRow justify="end"
               className="gap-[16px]">
        <Button caption={t('modals:warning:cancel')}
                onClick={() => props.onResult({}, "no")}
                layout="white" />
        <Button caption={t('modals:warning:delete')}
                onClick={() => props.onResult({}, "yes")}
                layout="warning_bg" />
      </FlexRow>
  </Modal>
  );
}

export interface ModalButtonProps {
  value:				string;
  caption:				string;
  layout:				"default" | "warning" | "white" | "warning_bg" | undefined;
}

export interface ButtonsModal extends ModalProps {
  buttons?:				ModalButtonProps[];
}

export const ButtonsModal = (mprops: ButtonsModal) => {
  const { t } = useTranslation();
  
  const {	children,
         	buttons,
         	...props
        } = mprops;
  
  const btns: ModalButtonProps[] =
  	buttons
	?	buttons
	:	[	{value: "no",	caption: t('modals:buttons:no'),	layout: "white"},
			{value: "yes",	caption: t('modals:buttons:yes'),	layout: "warning_bg"},
		];
  
  return (
  <Modal {...props}>
      { children }
      <FlexRow justify="end"
               className="gap-[16px]">
      {btns.map((btn: ModalButtonProps, i: number) =>
        <Button key={i}
                caption={btn.caption}
                onClick={() => props.onResult({}, btn.value)}
                layout={btn.layout} />
      )}
      </FlexRow>
  </Modal>
  );
}

export interface RightBarProps {
  onOpenChange:		ModalProps["onOpenChange"];
  children?:		React.ReactNode;
}

export const RightBar = (mprops: RightBarProps) => {
  const { children, ...props } = mprops;

  return (
    <MModal backdrop="opaque"
	       defaultOpen={true}
	       isDismissable={false}
	       classNames={{
	         backdrop: "bg-[#0000007f]",
	         wrapper: "justify-end"
	       }}
	       hideCloseButton={true}
	       radius="none"
	       placement="top"
	       {...props}>
	  <ModalContent className="h-full !mx-0 !my-0 w-full max-w-[620px]">
	    <ModalBody className="w-full !overflow-y-auto">
	      <FlexRow direction="column"
	               flex={0}>
	        { children }
	      </FlexRow>
	    </ModalBody>
	  </ModalContent>
	</MModal>
  );
}

export default Modal;

